/*
 * @Descripttion: 订单关怀效果数据汇总
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useEffect, useState, useRef} from 'react';
import {Tab, Button, DatePicker} from '@alifd/next';
import DDCFSummary from '../ddcfSummary';
import YSCFSummary from '../yscfSummary';
import DDCPSummary from '../ddcpSummary';
import moment from 'moment';
import styles from './index.module.scss';

const SummaryResult = () => {
  const ddcfRef = useRef();
  const yscfRef = useRef();
  const ddcpRef = useRef();

  const [currentTabKey, setCurrentTabKey] = useState('S_DDCF');
  const [formSelect, setFormSelect] = useState({
    startTime: moment().subtract(8, 'day'),
    endTime: moment().subtract(1, 'day'),
  });

  const changeActivityTime = (value) => {
    setFormSelect({
      ...formSelect,
      startTime: value[0],
      endTime: value[1],
    })
  };

  const searchData = () => {
    switch (currentTabKey) {
      case 'S_DDCF':
        ddcfRef?.current?.interfaceSearch();
        break;
      case 'S_YSCF':
        yscfRef.current.interfaceSearch();
        break;
      case 'S_DDCP':
        ddcpRef.current.interfaceSearch();
        break;
      default:
        break;
    }
  };

  const disabledDate = (date) => {
    return date.valueOf() > moment().valueOf();
  };

  return <div className={styles['summary-result-container']}>
      <Tab
        size="small"
        shape="capsule"
        navClassName="order-care-summary-result-tabs"
        onChange={(k) => setCurrentTabKey(k)}
        defaultActiveKey={currentTabKey}
        animation
      >
        <Tab.Item title="订单催付" key="S_DDCF">
          <DDCFSummary form={formSelect} ref={ddcfRef} />
        </Tab.Item>
        <Tab.Item title="预售催付" key="S_YSCF">
          <YSCFSummary form={formSelect} ref={yscfRef} />
        </Tab.Item>
        <Tab.Item title="订单催评" key="S_DDCP">
          <DDCPSummary form={formSelect} ref={ddcpRef} />
        </Tab.Item>
      </Tab>
      <div className={styles['position-absolute']}>
        <DatePicker.RangePicker
            disabledDate={disabledDate}
            placeholder={['开始时间', '结束时间']}
            popupAlign="tr tr"
            popupContainer={(target) => target.parentNode}
            value={[formSelect.startTime, formSelect.endTime]}
            onChange={changeActivityTime} />
        <Button type='primary' className={styles.btn} onClick={() => searchData()}>查询</Button>
        <Button className={styles.btn}>重置</Button>
      </div>
  </div>
};

export default SummaryResult;
